// @flow

import {paramsToQuery} from "../util/transform";
import ServiceError from "./ServiceError";


class BaseService {
    baseUrl: string;
    controller: AbortController;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
        this.controller = new AbortController();
    }

    async makeRequest(method: string, service: string, params: ?{}, body: ?any): Promise<any> {
        let options = { method, };
        if (body != null) {
            options.body = JSON.stringify({data: body});
            options.headers = {
                "Content-Type": "application/json; charset=UTF-8"
            };
        }
        const urlParams = paramsToQuery(params);
        const request = new Request(this.baseUrl + "/" + service + (params == null ? "" : "?" + urlParams), options);
        const response: Response = await fetch(request, {signal: this.controller.signal}).catch((error) => {
            console.error(error);
            throw new Error(error);
        });
        if (!response.ok) throw new ServiceError(response);
        return response.json();
    }

    async getData(service: string, params: ?{} = null): Promise<any> {
        return this.makeRequest("GET", service, params);
    }

    async postData(service: string, body: any): Promise<any> {
        return this.makeRequest("POST", service, null, body);
    }

    async putData(service: string, body: any): Promise<any> {
        return this.makeRequest("PUT", service, null, body);
    }

    async deleteData(service: string, params: ?{} = null): Promise<any> {
        return this.makeRequest("DELETE", service, params);
    }

    abort(): void {
        this.controller.abort();
    }
}

export default BaseService;
